module.exports = __webpack_public_path__ + "public/1.0.1_520583/img/computer.c10e044a.svg";